var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoustoStash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 216.7 200",
    style: {
      enableBackground: "new 0 0 216.7 200"
    },
    xmlSpace: "preserve",
    width: "3rem",
    height: "3rem",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st0 { fill: #333d45; }\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M215.8,62.4l-35.8,118c-3.3,11.1-14.7,19.7-25.9,19.7H33.9c-13.3,0-27.5-10.5-32.3-24.1 c-2.1-5.9-2.1-11.6-0.3-16.5c0.3-2.6,0.8-5.2,0.9-8.3c0.1-2.1-1-3.8-0.8-5.3c0.5-3.1,3.3-5.3,5.3-8.9c3.9-6.5,8.3-17.1,9.8-23.8 c0.7-2.5-0.7-5.3,0-7.6c0.7-2.5,3.1-4.3,4.4-6.6c3.5-6,8.1-17.6,8.7-23.7c0.3-2.7-1-5.7-0.3-7.8c0.9-3,3.8-4.3,5.7-6.9 c3.1-4.3,8.3-16.7,9.1-23.6c0.3-2.2-1-4.4-0.7-6.8c0.5-2.5,3.6-5.1,5.7-8.1c5.5-8.1,6.5-25.9,23-21.2l-0.1,0.4 C74.5,0.7,76.7,0,78.9,0H178c6.1,0,11.6,2.7,14.8,7.3c3.4,4.7,4.2,10.8,2.3,16.9l-35.7,118c-6.1,20.1-9.5,24.5-26,24.5H20.3 c-1.7,0-3.8,0.4-4.9,2c-1,1.6-1.2,2.7-0.1,5.6c2.6,7.6,11.6,9.1,18.7,9.1h120.2c4.8,0,10.4-2.7,11.8-7.4l39.1-128.5 c0.8-2.5,0.8-5.1,0.7-7.4c3,1.2,5.7,3,7.7,5.6C216.7,50.3,217.6,56.4,215.8,62.4z M67,83.3h79.2c2.2,0,4.7-1.8,5.5-4.2l2.7-8.3 c0.8-2.3-0.5-4.2-2.9-4.2H72.3c-2.2,0-4.7,1.8-5.5,4.2l-2.7,8.3C63.3,81.5,64.6,83.3,67,83.3z M77.8,50h79.2c2.2,0,4.7-1.8,5.5-4.2 l2.7-8.3c0.8-2.3-0.5-4.2-2.9-4.2H83.1c-2.2,0-4.7,1.8-5.5,4.2l-2.7,8.3C74.1,48.2,75.4,50,77.8,50z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoustoStash);
export default __webpack_public_path__ + "static/media/Gousto_Stash.43a4c8e4fdeed6b0c1bcc5b52e6f2774.svg";
export { ForwardRef as ReactComponent };